<script>
import NewModal from "@/components/UI/NewModal.vue";
import { mapState, mapWritableState } from "pinia";
import { useCategoryStore } from "@/app-store/category";
import ProductCard from "@/components/Menu/ProductCard.vue";
import { getLayoutStyling } from "@/utils/Styling";
import { useAppStore } from "@/app-store/app";
import UIButton from "@/components/UI/UIButton.vue";

export default {
  name: "UpSellModal",
  components: {
    UIButton,
    ProductCard,
    NewModal,
  },
  props: ["product", "products"],
  computed: {
    ...mapWritableState(useCategoryStore, ["isUpSellModalOpen"]),
    ...mapState(useAppStore, ["layoutConfig"]),
    styleVars() {
      const { layoutConfig, screenYOverflow } = this;
      return {
        ...getLayoutStyling(layoutConfig, screenYOverflow),
        height: this.baseHeight,
      };
    },
    bgClass() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.actionbar) return "bg-color-first";
      return `bg-color-${layoutConfig.actionbar.containerColor}`;
    },
    titleClasses() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.actionbar)
        return "bg-color-third text-black";
      return `font-${layoutConfig.actionbar.titleFont} max-md:text-xl md:text-${layoutConfig.actionbar.titleTextSize} text-color-${layoutConfig.actionbar.titleTextColor}`;
    },
    primaryButtonClasses() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.actionbar)
        return "bg-color-third text-white";
      let shapeClass = "rounded-none";
      switch (layoutConfig.actionbar.primaryButtonShape) {
        case "rounded":
          shapeClass = "rounded-xl";
          break;
        case "full-rounded":
          shapeClass = "rounded-full";
          break;
      }
      return `${shapeClass} bg-color-${layoutConfig.actionbar.primaryButtonBackgroundColor} text-color-${layoutConfig.actionbar.primaryButtonTextColor} font-${layoutConfig.actionbar.primaryButtonFont} border-2 border-color-${layoutConfig.actionbar.primaryButtonBorderColor} max-md:text-xl md:text-${layoutConfig.actionbar.primaryButtonTextSize}`;
    },
  },
  methods: {
    exit() {
      this.isUpSellModalOpen = false;
      this.$emit("exit");
    },
  },
};
</script>

<template>
  <new-modal v-model="isUpSellModalOpen" :skip-out-exit="true">
    <div
      :class="`w-[100%] md:w-[90%] mx-auto ${bgClass} p-5`"
      :style="styleVars"
    >
      <h4 :class="`${titleClasses} text-center py-5`">You may also like</h4>
      <div :class="`w-full grid grid-cols-1 gap-4 md:grid-cols-3`">
        <router-link
          @click="isUpSellModalOpen = false"
          :to="`/products/${p._id}?upsell=${product._id}`"
          :id="p._id"
          v-for="p of products"
          :key="p._id"
        >
          <ProductCard :product="p" />
        </router-link>
      </div>
      <div class="py-3">
        <u-i-button @click="exit" :class="`w-full ${primaryButtonClasses}`">
          Maybe next time, thanks</u-i-button
        >
      </div>
    </div></new-modal
  >
</template>

<style scoped></style>
